import { ButtonEmpty } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import s from './BuyButton.module.scss'

export default function BuyButton() {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <div className={s['buy-button']}>
      <ButtonEmpty className="button-primary-lg" onClick={goToBuyPage}>
        {t('common.buyTickets')}
      </ButtonEmpty>
    </div>
  )

  function goToBuyPage() {
    history.push('/buy')
  }
}
